import { render, staticRenderFns } from "./MoveRepsSlideItem.vue?vue&type=template&id=53a6b872&scoped=true&"
import script from "./MoveRepsSlideItem.vue?vue&type=script&lang=js&"
export * from "./MoveRepsSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./MoveRepsSlideItem.vue?vue&type=style&index=0&id=53a6b872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6b872",
  null
  
)

export default component.exports